import { render } from "./useranswer.vue?vue&type=template&id=c5878684"
import script from "./useranswer.vue?vue&type=script&lang=js"
export * from "./useranswer.vue?vue&type=script&lang=js"

import "./useranswer.vue?vue&type=style&index=0&id=c5878684&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__